import script from "./OrderNewCalc.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderNewCalc.vue?vue&type=script&setup=true&lang=js"

import "./OrderNewCalc.vue?vue&type=style&index=0&id=0b779241&lang=sass"

export default script